export const ANALYTICS_WORKFLOWS = {
  hoursReporting: "hours_reporting",
  apiRequest: "api_request",
  authentication: "authentication",
  puPlanning: "pu_planning",
  absence: "absence",
  reportExport: "report_export",
  crmImport: "crm_import",
} as const;

export const ANALYTICS_OPERATIONS = {
  hoursReporting: {
    opened: "hours_reporting.opened",
    extraWorkOpened: "hours_reporting.extra_work_opened",
    extraWorkCancelled: "hours_reporting.extra_work_cancelled",
    extraWorkConfirmed: "hours_reporting.extra_work_confirmed",
    submissionStarted: "hours_reporting.submission_started",
    succeeded: "hours_reporting.succeeded",
    failed: "hours_reporting.failed",
  },
  apiNetworkFailed: "api.network_failed",
} as const;
